module.exports = __webpack_public_path__ + "static/media/schoolbg.33a3b67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/schoolbg.jpg
// module id = 378
// module chunks = 0